import { render, staticRenderFns } from "./SecurityPassword.vue?vue&type=template&id=5d5022cd&scoped=true&"
import script from "./SecurityPassword.vue?vue&type=script&lang=js&"
export * from "./SecurityPassword.vue?vue&type=script&lang=js&"
import style0 from "./SecurityPassword.vue?vue&type=style&index=0&id=5d5022cd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5022cd",
  null
  
)

component.options.__file = "SecurityPassword.vue"
export default component.exports